/**
 * Generated file, do not edit directly!
 */

/** Breakpoints are used to adjust the layout and appearance of elements in the interface based on different screen sizes. */

const Max = {
  /**
   * Use with `@media` `max-width` to apply styles to mobile-sized screens.
   * Css custom property: --dt-breakpoints-max-mobile. Default value: 640px.
   */
  Mobile: 'var(--dt-breakpoints-max-mobile, 640px)',
  /**
   * Use with `@media` `max-width` to apply styles to tablets and smaller screens.
   * Css custom property: --dt-breakpoints-max-tablet. Default value: 960px.
   */
  Tablet: 'var(--dt-breakpoints-max-tablet, 960px)',
  /**
   * Use with `@media` `max-width` to apply styles to desktops and smaller screens.
   * Css custom property: --dt-breakpoints-max-desktop. Default value: 1920px.
   */
  Desktop: 'var(--dt-breakpoints-max-desktop, 1920px)',
};
const Min = {
  /**
   * Use this with `@media` `min-width`, to apply styles to tablet and wider screen sizes.
   * Css custom property: --dt-breakpoints-min-tablet. Default value: 641px.
   */
  Tablet: 'var(--dt-breakpoints-min-tablet, 641px)',
  /**
   * Use this with `@media` `min-width`, to apply styles to desktop and wider screen sizes.
   * Css custom property: --dt-breakpoints-min-desktop. Default value: 961px.
   */
  Desktop: 'var(--dt-breakpoints-min-desktop, 961px)',
  /**
   * Use this with `@media` `min-width`, to apply styles to widescreen desktop and wider screen sizes.
   * Css custom property: --dt-breakpoints-min-widescreen. Default value: 1921px.
   */
  Widescreen: 'var(--dt-breakpoints-min-widescreen, 1921px)',
};
export default {
  Max,
  Min,
};
